import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["title"]

import {
  TUIChatService,
  TUIStore,
  StoreName,
  IConversationModel,
  SendMessageParams,
  SendMessageOptions,
  TUITranslateService
} from '../../../../@aidesk/uikit-engine';
import vue from '../../../../adapter-vue';
import ToolbarItemContainer from '../toolbar-item-container/index.vue';
import fileIcon from '../../../../assets/files.svg';
import fileIconH5 from '../../../../assets/file-h5.png';
import { isPC, isH5 } from '../../../../utils/env';
import { isEnabledMessageReadReceiptGlobal, getTo } from '../../../../utils/utils';
import Log from '../../../../utils/logger';
import { Toast, TOAST_TYPE } from '../../../common/Toast/index-web';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  title: {
    type: String,
  },
},
  setup(__props) {

const { ref } = vue;

const props = __props;

const inputRef = ref();
const currentConversation = ref<IConversationModel>();

TUIStore.watch(StoreName.CONV, {
  currentConversation: (conversation: IConversationModel) => {
    currentConversation.value = conversation;
  },
});

const onIconClick = () => {
  inputRef?.value?.click && inputRef?.value?.click();
};

const sendFileMessage = (e: any) => {
  if (e?.target?.files?.length <= 0) {
    return;
  }
  const file = e.target.files[0];
  if (!file || !file.size) {
    return;
  }
  const options = {
    to: getTo(currentConversation?.value),
    conversationType: currentConversation?.value?.type,
    payload: {
      file: e.target,
    },
    needReadReceipt: isEnabledMessageReadReceiptGlobal(),
  } as SendMessageParams;
  const sendMessageOptions: SendMessageOptions = {};
  TUIChatService.sendFileMessage(options, sendMessageOptions)
  .catch((err) => {
    Toast({
      message:
        err.code === 2402 ? 
          TUITranslateService.t('AIDesk.file 大小超过 100MB，无法发送') 
        : err.message,
      type: TOAST_TYPE.ERROR,
      duration: 5000,
    });
    Log.l(`Send File Failed:${err.code} ${err.message}`);
  });
  e.target.value = '';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ToolbarItemContainer, {
    iconFile: _unref(isH5) ? _unref(fileIconH5) : _unref(fileIcon),
    title: props.title || _unref(TUITranslateService).t('文件'),
    iconWidth: "20px",
    iconHeight: "20px",
    needDialog: false,
    onOnIconClick: onIconClick
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(['file-upload', !_unref(isPC) && 'file-upload-h5'])
      }, [
        _createElementVNode("input", {
          ref_key: "inputRef",
          ref: inputRef,
          title: props.title || _unref(TUITranslateService).t('文件'),
          type: "file",
          "data-type": "file",
          accept: "*",
          onChange: sendFileMessage
        }, null, 40, _hoisted_1)
      ], 2)
    ]),
    _: 1
  }, 8, ["iconFile", "title"]))
}
}

})